module.exports = __webpack_public_path__ + "img/EmphasisWealth.f9f1479d.png";